import { getIdToken, getAuth, get } from "firebase/auth";
import axios from "axios";

export const axiosInstance = axios.create({
  //baseURL: "https://apis-pcari-gigs.pcari.my/api/v1",
  // baseURL: "https://stage-star-api.pcari.my/api/v1/",
  // baseURL: "http://pcari-star.test/api/v1/",
  // baseURL: "http://192.168.0.176:8000/api/v1",
  baseURL: process.env.GIGS_URL
});

export const adminAPIInstance = axios.create({
  // baseURL: "https://stage-star-api.pcari.my/admin-api/v1/",
  // baseURL: "http://192.168.0.176:8000/api/v1",
  baseURL: process.env.ADMIN_URL
});

export const stageAdminAPIInstance = axios.create({
  //baseURL: "https://stage-star-api.pcari.my/admin-api/v1/",
  // baseURL: "http://192.168.0.176:8000/api/v1",
  baseURL: process.env.GIGS_ADMIN_URL
});

axiosInstance.interceptors.request.use(
  async function (config) {
    const token = sessionStorage?.getItem("idToken") ?? null;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

adminAPIInstance.interceptors.request.use(
  async function (config) {
    const token = sessionStorage?.getItem("idToken") ?? null;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

stageAdminAPIInstance.interceptors.request.use(
  async function (config) {
    const token = sessionStorage?.getItem("idToken") ?? null;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);
